import {createSlice} from '@reduxjs/toolkit';

export const themeState = createSlice({
  name: 'themeStore',
  initialState: {
    fontFamily: '',
    fontFaceSrcMap: {},
  },
  reducers: {
    updateFontFamily: (state, action) => {
      state.fontFamily = action.payload;
    },
    /**
     *
     * @param {*} state
     * @param {{payload: {fontName: string, fontSrc: string}}} action
     */
    setFontFaceSrc: (state, action) => {
      state.fontFaceSrcMap[action.payload.fontName] = action.payload.fontSrc;
    },
  },
});

export const {
  setFontFaceSrc,
  updateFontFamily,
} = themeState.actions;

export default themeState.reducer;
